import {Flag, Tooltip} from 'platform/components';

import {isNil} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {getClassifiedsAdInactiveReason} from '../../utils/isClassifiedsAdInactive';

interface ClassifiedsSoldFlagProps extends TestIdProps {
  sourcingVehicle?: SourcingVehicleResponseBody | null;
}

export function ClassifiedsSoldFlag(props: ClassifiedsSoldFlagProps) {
  const inactiveReason = getClassifiedsAdInactiveReason(props.sourcingVehicle);

  if (isNil(inactiveReason)) {
    return null;
  }

  const tooltipLabel =
    inactiveReason === 'availabilityCheck'
      ? i18n.t('entity.sourcing.labels.justSoldTooltip')
      : i18n.t('entity.sourcing.labels.inactiveAdvertisementTooltip');

  return (
    <Tooltip label={tooltipLabel}>
      <Flag
        label={i18n.t('entity.vehicle.labels.sold')}
        size="small"
        data-testid={props['data-testid']}
      />
    </Tooltip>
  );
}
